import { IConstants } from '../../models/pro-sites';
import { LOAD_CONSTANTS_SUCCESS } from './externals-actions';

interface ILoadConstantsAction {
    type: 'LOAD_CONSTANTS_SUCCESS';
    constants: IConstants;
}

type KnownAction = ILoadConstantsAction;

export const constantsReducer = (
    state: IConstants | null | undefined = null,
    action: KnownAction
) => {
    switch (action.type) {
        case LOAD_CONSTANTS_SUCCESS:
            return action.constants;
        default:
            return state;
    }
};
